import React from 'react';

// Consistent inner-page hero with image + title
const PageHero = ({ eyebrow, title, image, height = 'h-[62vh]' }) => {
  return (
    <section className={`relative ${height} min-h-[420px] w-full`}>
      <div className="img-hover-zoom absolute inset-0">
        <img src={image} alt={title} className="h-full w-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-ink/40" />
      <div className="relative h-full mx-auto max-w-[1500px] px-6 md:px-12 flex flex-col justify-end pb-16 md:pb-20">
        <div className="text-bone max-w-3xl">
          {eyebrow && (
            <p className="text-[11px] uppercase tracking-[0.35em] mb-5 text-bone/80">{eyebrow}</p>
          )}
          <h1 className="font-serif font-light text-4xl md:text-6xl leading-[1.05]">{title}</h1>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
